/**
 *
 * all toast types that are assignable
 *
 * @export
 * @enum ToastTypes
 */
export enum ToastTypes {
  Success = "toast-success",
  Error = "toast-error",
  Warning = "toast-warning",
  Info = "toast-info",
  Default = "toast-default",
  ActionToast = "toast-action",
}
